// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={71}
    height={70}
    viewBox="0 0 71 70"
    {...props}
  >
    <path
      d="M20.5479 13.3408C21.4683 13.3408 22.2009 13.5618 22.9749 14.3843L34.579 26.7036H16.1834C15.0112 26.7036 13.8871 26.2445 13.0582 25.4273C12.2294 24.6102 11.7638 23.5019 11.7638 22.3462H10.0607C8.88932 22.3462 7.76586 21.8875 6.9374 21.071C6.10893 20.2546 5.64327 19.1471 5.64281 17.9922V17.846H4.95332C4.37301 17.8463 3.79833 17.7338 3.26213 17.515C2.72593 17.2962 2.2387 16.9754 1.82827 16.5709C1.41785 16.1664 1.09227 15.6862 0.870146 15.1576C0.648018 14.6291 0.533691 14.0625 0.533691 13.4904V13.3442L20.5479 13.3408Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M5.64355 17.8418H20.1504"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M23.781 22.3457H11.7632"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M50.4542 13.3408C49.5337 13.3408 48.8012 13.5618 48.0272 14.3843L36.4248 26.7036H54.8204C55.4007 26.7036 55.9753 26.5909 56.5115 26.3719C57.0476 26.1529 57.5347 25.8318 57.9449 25.4272C58.3552 25.0226 58.6806 24.5422 58.9025 24.0135C59.1244 23.4849 59.2385 22.9183 59.2383 22.3462H60.9413C62.1135 22.3462 63.2376 21.8871 64.0665 21.0699C64.8953 20.2528 65.361 19.1445 65.361 17.9888V17.8427H66.0505C67.2222 17.8427 68.3459 17.3837 69.1744 16.5669C70.0029 15.75 70.4684 14.6422 70.4684 13.487V13.3408H50.4542Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M65.3672 17.8418H50.8604"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M47.228 22.3457H59.2458"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M35.4108 9.10059L5.32666 61.0068H65.495L35.4108 9.10059Z"
      fill="#C9C8D0"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M38.0033 27.2422H32.8184V46.0653H38.0033V27.2422Z"
      fill="#FCFBF7"
    />
    <path
      d="M38.1062 51.3484C38.1062 52.0533 37.8221 52.7294 37.3166 53.2278C36.811 53.7263 36.1253 54.0063 35.4103 54.0063C34.6953 54.0063 34.0095 53.7263 33.504 53.2278C32.9984 52.7294 32.7144 52.0533 32.7144 51.3484C32.7144 50.6435 32.9984 49.9674 33.504 49.469C34.0095 48.9705 34.6953 48.6904 35.4103 48.6904C36.1253 48.6904 36.811 48.9705 37.3166 49.469C37.8221 49.9674 38.1062 50.6435 38.1062 51.3484Z"
      fill="#FCFBF7"
    />
  </svg>
);
const SvgWarningWingsGreyscale = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgWarningWingsGreyscale;
